// src/components/LazySection.tsx
import { useState, useEffect, useRef, ReactNode } from 'react';

const LazySection = ({ children, sectionId }: { children: ReactNode, sectionId: string }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => entry.isIntersecting && setIsVisible(true),
            { rootMargin: '200px' }
        );
        
        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    return <div ref={ref} data-section={sectionId}>
        {isVisible ? children : <LoadingPlaceholder />}
    </div>;
};

const LoadingPlaceholder = () => (
    <div style={{ height: '300px', background: '#f5f5f5' }} />
);

export default LazySection;